/**
 * 充值记录路由
 */
const RechargeRouter = {
  path: 'recharge',
  name: 'Recharge',
  meta: {
    requiresAuth: false,
    leftMenu: true          // false表示不需要左边菜单栏
  },
  component: () => import('@/views/Recharge/index')
}
export default RechargeRouter
